import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone, ChevronRight } from "lucide-react";
import { company, navLinks } from "../mock/mock";
import { Button } from "./ui/button";
import logo from "../assets/logo.png";

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50">
      {/* Announcement bar */}
      <a
        href={`mailto:${company.salesEmail}?subject=We%20Are%20Upgrading%20our%20Phone%20System`}
        className="block brand-gradient text-white text-xs sm:text-sm text-center py-2 px-4 hover:opacity-95 transition-opacity"
      >
        {company.announcement}
      </a>

      <nav
        className={`w-full transition-all duration-300 ${
          scrolled ? "bg-white/95 backdrop-blur shadow-md" : "bg-white"
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 lg:h-20">
            {/* Logo */}
            <Link to="/" className="flex items-center shrink-0">
              <img
                src={logo}
                alt="Morrisville Communications"
                className="h-9 lg:h-11 w-auto"
              />
            </Link>

            {/* Desktop links */}
            <div className="hidden xl:flex items-center gap-1">
              {navLinks.slice(0, -1).map((l) => (
                <Link
                  key={l.path}
                  to={l.path}
                  className={`px-2.5 py-2 text-sm font-medium rounded-lg transition-colors underline-grow whitespace-nowrap ${
                    isActive(l.path)
                      ? "text-blue-700"
                      : "text-slate-700 hover:text-blue-700"
                  }`}
                >
                  {l.label}
                </Link>
              ))}
            </div>

            <div className="hidden xl:flex items-center gap-3">
              <a
                href={`tel:${company.phoneTel}`}
                className="text-sm font-semibold text-slate-700 hover:text-blue-700 flex items-center gap-1.5 whitespace-nowrap"
              >
                <Phone className="h-4 w-4" /> {company.phone}
              </a>
              <Link to="/contact">
                <Button className="brand-gradient text-white rounded-full px-5 font-semibold">
                  Free Consultation
                </Button>
              </Link>
            </div>

            {/* Mobile toggle */}
            <button
              className="xl:hidden p-2 text-slate-800"
              onClick={() => setOpen(!open)}
              aria-label="Toggle menu"
            >
              {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {open && (
          <div className="xl:hidden border-t border-slate-100 bg-white">
            <div className="px-4 py-3 space-y-1">
              {navLinks.map((l) => (
                <Link
                  key={l.path}
                  to={l.path}
                  className={`flex items-center justify-between px-3 py-3 rounded-lg text-[15px] font-medium ${
                    isActive(l.path)
                      ? "bg-blue-50 text-blue-700"
                      : "text-slate-700 hover:bg-slate-50"
                  }`}
                >
                  {l.label}
                  <ChevronRight className="h-4 w-4 opacity-50" />
                </Link>
              ))}
              <a
                href={`tel:${company.phoneTel}`}
                className="flex items-center gap-2 px-3 py-3 text-blue-700 font-semibold"
              >
                <Phone className="h-4 w-4" /> {company.phone}
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Navbar;
